import React, { FC, memo } from 'react'

import { InterSvgIcon } from 'components'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

import {
  Container,
  NotificationIcon,
  TextContentContaier,
} from '../styles/DontDisturbBottomsheet.styles'
import { TDontDisturbBottonsheeViewProps } from '../types/DontDisturbBottomsheet.types'

export const DontDisturbBottomsheetView: FC<TDontDisturbBottonsheeViewProps> = memo(
  ({ confirmButton, details, icon, site, title, onClose }) => (
    <Container>
      {icon && (
        <NotificationIcon>
          <InterSvgIcon iconRef={icon} width={32} height={32} color="var(--typography500)" />
        </NotificationIcon>
      )}
      <TextContentContaier>
        <Text variant="headline-h3" color="typography" colorWeight={500} as="p" semiBold>
          {title}
        </Text>
        <Text variant="body-3" color="typography" colorWeight={400} as="p">
          {details}
          <strong> {site}</strong>.
        </Text>
      </TextContentContaier>
      <Button onClick={onClose} style={{ width: '100%', marginTop: '16px' }}>
        {confirmButton}
      </Button>
    </Container>
  ),
)
